var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    attrs: {
      id: "sidebar-motoboy-add-order",
      title: _vm.$t("Adicionar pedido à entrega"),
      show: _vm.show,
      "hide-save-button": true,
      "cancel-button-text": _vm.$t("Fechar"),
      "no-close-on-backdrop": false,
      width: "30%",
    },
    on: {
      hidden: function ($event) {
        return _vm.$emit("hidden")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _vm.motoboy
              ? _c("p", { staticClass: "mb-1" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.$t("Motoboy")) + ":")]),
                  _vm._v(" " + _vm._s(_vm.motoboyName(_vm.motoboy)) + " "),
                ])
              : _vm._e(),
            _c("small", { staticClass: "text-muted d-block mb-1" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "O pedido adicionado entra na entrega em andamento deste Motoboy."
                    )
                  ) +
                  " "
              ),
            ]),
            _c("FormulateInput", {
              attrs: {
                id: "motoboy-add-order-sidebar_filter",
                type: "text",
                label: _vm.$t("Pedido ou cliente"),
                placeholder: _vm.$t(
                  "Filtrar por número do pedido ou nome do cliente"
                ),
              },
              model: {
                value: _vm.orderFilter,
                callback: function ($$v) {
                  _vm.orderFilter = $$v
                },
                expression: "orderFilter",
              },
            }),
            _c(
              "b-alert",
              {
                staticClass: "mb-0",
                attrs: { show: !_vm.filteredOrders.length, variant: "light" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.ordersWaitingMotoboy.length
                        ? _vm.$t(
                            "Nenhum pedido encontrado para o filtro informado"
                          )
                        : _vm.$t("Nenhum pedido aguardando Motoboy")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "ul",
              { staticClass: "motoboy-add-order-list list-unstyled mb-0" },
              _vm._l(_vm.filteredOrders, function (order) {
                return _c(
                  "li",
                  {
                    key: order.id,
                    staticClass:
                      "motoboy-add-order-list__item d-flex align-items-center justify-content-between",
                  },
                  [
                    _c("div", [
                      _c("strong", [_vm._v("#" + _vm._s(order.id))]),
                      order.customer && order.customer.name
                        ? _c("span", [
                            _vm._v(" - " + _vm._s(order.customer.name)),
                          ])
                        : _vm._e(),
                      order.deliveryAddress
                        ? _c("small", { staticClass: "text-muted d-block" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatOrderAddress(order.deliveryAddress)
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("e-button", {
                      attrs: {
                        id: "motoboy-add-order-sidebar_add-" + order.id,
                        size: "sm",
                        icon: "plus-circle",
                        busy: _vm.isAssignmentOperationPending(order.id),
                        text: _vm.$t("Adicionar"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.addOrder(order)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }